import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GeneralServiceService } from 'src/app/general-service.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  inputType = "password"
  private emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  private passwordRegex = /\b\d{5}\b/g
  
  constructor(
    private router:Router,
    private generalService : GeneralServiceService
  ){

  }

  errorDisplay = false;
  username : any
  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required])
  });

  get email() { return this.loginForm.get('email') }
  get password() { return this.loginForm.get('password') }

  login() {
    this.loginForm.markAllAsTouched();
    if (this.loginForm.invalid) {
      return;
    }
    const email = this.loginForm.get('email')?.value;
    const password = this.loginForm.get('password')?.value;
    
    this.generalService.verifyUser(email, password).subscribe({
      next: (response) => {
        const location = response.location;
        const token = response.token;
        //this.generalService.setCategory(location);
        this.username = email;
        sessionStorage.setItem("username", this.username)
        sessionStorage.setItem("Location",location)
        sessionStorage.setItem("token",token)
        this.router.navigateByUrl('/');
        //console.log("Response is", response)
        this.errorDisplay = false
      },
      error: (err) => {
        this.errorDisplay = true
        console.error('Login failed', err);
        setTimeout(() => {
          this.errorDisplay = false;
        }, 5000);
      }
    });

  }
}
